/**
 *
 * VehicleType12970 constants
 *
 */

export const BUS = '3810974362000';
